export const categories = [
  { id: "all", name: "全部栏目", desc: "按时间聚合的全部爆料" },
  { id: "business", name: "商业暗账", desc: "品牌、门店与资本层面的账目疑点" },
  { id: "industry", name: "行业黑幕", desc: "渠道、供应与规则背后的潜逻辑" },
  { id: "workplace", name: "职场内幕", desc: "合同、考核与人事里的隐形条款" },
  { id: "gray", name: "灰色地带", desc: "游走在合规边缘的操作链条" },
  { id: "network", name: "网络暗涌", desc: "流量、数据与水军背后的生意" },
  { id: "society", name: "民生暗角", desc: "社区、校园与日常消费里的盲区" },
];

export const stories = [
  {
    id: "chain-kitchen-oil",
    title: "连锁快餐后厨的“回锅油”账本",
    categoryId: "business",
    category: "商业暗账",
    excerpt:
      "一封来自区域督导的手写记录：油炸用油的更换周期被反复拉长，报废记录用一支笔“对齐”，而成本考核表上写着另一个数字。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20investigative%20magazine%20illustration%20of%20an%20industrial%20kitchen%20counter%20at%20night%2C%20muted%20warm%20palette%20of%20brick%20red%20amber%20and%20charcoal%2C%20grainy%20paper%20texture%2C%20dramatic%20chiaroscuro%20lighting%2C%20abstract%20documentary%20collage%2C%20no%20text%2C%20high%20detail&width=900&height=560&seq=heian-story-01-cover-2026&orientation=landscape",
    source: "线人代号 · 灶台九号",
    region: "华东某市",
    date: "2026-08-28",
    readMinutes: 7,
    heat: 9820,
    verified: true,
    tags: ["连锁餐饮", "后厨管理", "成本考核"],
    timeline: [
      { date: "2024 春", text: "区域门店开始执行新版“耗材成本红线”，油品预算被压缩约一成。" },
      { date: "2025 秋", text: "多门店出现“跨日复用”记录，报废台账与实际不符。" },
      { date: "2026 夏", text: "线人将手写督导记录与两张后台截图一并提交。" },
    ],
    sections: [
      {
        heading: "一本被反复涂改的报废台账",
        paragraphs: [
          "线人是华东区的巡店督导，负责抽查门店的耗材与卫生记录。他给我们看的不是文件，而是一本被橡皮擦磨得发亮的台账。按照公司制度，油炸用油需要按使用时长和酸价检测结果更换，每次报废都要记录时间、批次和去向。",
          "“到店抽查的时候，我经常看到同一支笔的墨色从深到浅，中间的几行明显是后补的。”他描述，当月度成本指标临近红线，部分店长会把报废日期整体往前挪一两天，让统计口径里的“平均使用时长”落在合格区间内。",
          "台账之外，还有一张后台的成本看板截图。截图里同一家门店的“油品报废量”在两套系统之间相差将近三成，而那部分差额，在月末被归入了“其他损耗”。",
        ],
      },
      {
        heading: "指标如何一步步挤压操作空间",
        paragraphs: [
          "线人认为问题的起点并不在某一个店长，而在考核方式。“总部把油品成本做成百分比，层层下压到区域、到店、到人。达标有奖，超标扣绩效，但没有人问过：这条线到底有没有留出正常换油的空间。”",
          "他回忆，曾有一位店长在例会上提出设备老化导致耗油偏高，得到的回复是“先想办法”。从那之后，这位店长再没在公开场合提过耗材的问题。",
        ],
      },
      {
        heading: "我们核对到的部分细节",
        paragraphs: [
          "我们依据线人提供的门店编号，比对了公开的门店评价信息，发现该片区数家门店在近半年内出现过集中性的“油味偏重”类差评，时间点与台账异常期大致重合。这不能直接证明因果关系，但值得继续追问。",
          "需要说明的是，这是一份线人口述与部分书面材料交织的稿件，涉及的具体门店与人员均已做脱敏处理。我们已就核心疑问向相关品牌方发出问询，截至发稿未收到正面回应。",
        ],
      },
    ],
    responses: [
      {
        from: "相关品牌方（未回应）",
        text: "我们在稿件发布前通过公开邮箱发出问询，截至发稿未收到正面回复。稿件保留后续补充的空间。",
      },
      {
        from: "前门店员工（匿名）",
        text: "换油这件事，标准一直在，执行看店长心情。忙的时候谁顾得上检测酸价。",
      },
    ],
  },
  {
    id: "mcn-hidden-penalty",
    title: "MCN 合约里的“隐形违约金”",
    categoryId: "industry",
    category: "行业黑幕",
    excerpt:
      "签约时只看分成比例，解约时才发现成本、投流与“账号归属”被算成一笔违约金。三位离职主播讲述了同一套流程。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20investigative%20magazine%20illustration%20of%20stacked%20contract%20papers%20and%20a%20ring%20light%20in%20shadow%2C%20muted%20warm%20palette%20of%20brick%20red%20amber%20and%20charcoal%2C%20grainy%20paper%20texture%2C%20dramatic%20side%20lighting%2C%20abstract%20documentary%20collage%2C%20no%20text%2C%20high%20detail&width=900&height=560&seq=heian-story-02-cover-2026&orientation=landscape",
    source: "线人代号 · 尾灯",
    region: "华南某市",
    date: "2026-08-24",
    readMinutes: 8,
    heat: 8640,
    verified: false,
    tags: ["直播行业", "合同条款", "账号归属"],
    timeline: [
      { date: "2023 冬", text: "主播与机构签约，合同正文仅数页，附件多达二十余项。" },
      { date: "2025 夏", text: "主播提出解约，收到包含“培养成本”的违约金清单。" },
      { date: "2026 春", text: "多位前主播整理出相似的费用明细。" },
    ],
    sections: [
      {
        heading: "签字的那一页，只有分成比例",
        paragraphs: [
          "三位来自不同城市的前主播，独立讲述了几乎相同的签约场景：一页 A4 纸的正文挂着醒目的分成比例，剩下厚厚一叠附件，签约现场被引导着“先签再说”。",
          "“他们让我签的是正文，附件说回头补。”其中一位回忆，“我当时想的是先把账号做起来。”账号是按机构要求注册的，实名材料交在机构手里，这一步后来成了争议的核心。",
        ],
      },
      {
        heading: "解约时凭空出现的成本清单",
        paragraphs: [
          "当主播提出解约，清单出现了：投流费用、拍摄成本、运营人力，甚至包括“机会成本”。多项费用没有对应的原始凭证，却都被计入了违约金基数。",
          "我们看到的几份清单里，同一个栏目在不同主播的账上金额差距极大，且大多以“预估”“折算”标注。换句话说，这不是一份能逐条核对清楚的账单。",
        ],
      },
      {
        heading: "账号到底属于谁",
        paragraphs: [
          "争议最集中的是账号归属。合同附件约定账号归机构运营管理，但主播主张账号内容与个人形象强绑定。当主播离开，粉丝与历史内容被留在原账号，个人 IP 的积累归零。",
          "法律层面对“账号归属”的认定仍存在讨论空间，本稿仅呈现双方陈述，不对个案下结论。我们已将问询发至涉事机构公开邮箱，截至发稿未获回应。",
        ],
      },
    ],
    responses: [
      {
        from: "涉事机构（未回应）",
        text: "我们尝试通过公开渠道联系涉事机构，截至发稿未收到回复。",
      },
    ],
  },
  {
    id: "voluntary-overtime-system",
    title: "一家中型公司的“自愿加班”打卡系统",
    categoryId: "workplace",
    category: "职场内幕",
    excerpt:
      "系统里没有“强制加班”这个按钮，但有一条看不见的规则：晚走的人排名靠前，而排名决定了下个季度的项目分配。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20investigative%20magazine%20illustration%20of%20empty%20office%20desks%20lit%20by%20laptops%20at%20night%2C%20muted%20warm%20palette%20of%20brick%20red%20amber%20and%20charcoal%2C%20grainy%20paper%20texture%2C%20dramatic%20chiaroscuro%20lighting%2C%20abstract%20documentary%20collage%2C%20no%20text%2C%20high%20detail&width=900&height=560&seq=heian-story-03-cover-2026&orientation=landscape",
    source: "线人代号 · 靠窗第二排",
    region: "华北某市",
    date: "2026-08-19",
    readMinutes: 6,
    heat: 7330,
    verified: true,
    tags: ["职场", "考核制度", "加班文化"],
    timeline: [
      { date: "2024 秋", text: "公司上线新的工时统计模块，对外称用于“弹性办公”。" },
      { date: "2025 全年", text: "工时排名与项目优先级出现明显相关性。" },
      { date: "2026 夏", text: "线人保存了多个月份的排名截图与内部邮件。" },
    ],
    sections: [
      {
        heading: "一个叫“活跃度”的隐藏指标",
        paragraphs: [
          "线人是产品部门的一名中层。他告诉我们，系统升级后多了一个叫“活跃度”的模块，界面里看不出用途，但主管的周报里能看到工时排名。",
          "“它不叫加班，叫活跃。谁走得晚，谁的数字好看。”他说，排名靠前的人，在下一个季度的重点项目里更容易被点名，久而久之大家就明白了规则。",
        ],
      },
      {
        heading: "拒绝加班的人，被写进了另一个名单",
        paragraphs: [
          "线人保留了几份内部邮件，邮件里用词谨慎，从未出现“必须加班”。但其中一封提到了“团队协同投入度”，并列出了几位“需要关注”的员工。",
          "这些员工的共同点，是准时上下班。半年内，其中两人先后离职。离职面谈记录上写的理由都是“个人发展”。",
        ],
      },
      {
        heading: "制度设计的灰色空间",
        paragraphs: [
          "把强制伪装成自愿，是这类系统的共同特征。它不需要一条明文规定，只需要让数据可见、让比较发生。",
          "我们已将核心问题发送至该公司公开邮箱，截至发稿未获回应。本稿对涉及的姓名与具体岗位做了处理。",
        ],
      },
    ],
    responses: [
      {
        from: "该公司（未回应）",
        text: "截至发稿，公司方面未就工时统计模块的用途作出回应。",
      },
    ],
  },
  {
    id: "livestream-water-curve",
    title: "直播间里那条“注水”的销量曲线",
    categoryId: "network",
    category: "网络暗涌",
    excerpt:
      "一场看似火爆的直播，后台的下单量、退货率和实际结算额是三条互相打架的曲线。一位运营讲述了“凑单—退货”的标准流程。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20investigative%20magazine%20illustration%20of%20glowing%20data%20charts%20rising%20above%20a%20dark%20studio%20set%2C%20muted%20warm%20palette%20of%20brick%20red%20amber%20and%20charcoal%2C%20grainy%20paper%20texture%2C%20dramatic%20lighting%2C%20abstract%20documentary%20collage%2C%20no%20text%2C%20high%20detail&width=900&height=560&seq=heian-story-04-cover-2026&orientation=landscape",
    source: "线人代号 · 后台小黑",
    region: "华东某市",
    date: "2026-08-15",
    readMinutes: 7,
    heat: 6910,
    verified: false,
    tags: ["直播电商", "数据", "退货率"],
    timeline: [
      { date: "2025 春", text: "团队开始使用外部“资源”为主要场次做准备。" },
      { date: "2025 冬", text: "多场直播的次日退货率显著高于日常场次。" },
      { date: "2026 春", text: "线人保存了结算后台与销售后台的多张截图。" },
    ],
    sections: [
      {
        heading: "先把数字做上去，再谈别的",
        paragraphs: [
          "线人做过某品牌自播间的运营。他描述的开场并不是选品，而是“资源对接”：在正式开播前，某些订单会被提前安排，确保开场的数据足够好看。",
          "“平台看的是开场的爆发力，数据起来，自然流量才愿意进来。”订单有了，人气有了，接下来就是处理这些订单的去向。",
        ],
      },
      {
        heading: "凑单与退货之间的一小段时间差",
        paragraphs: [
          "大部分“注水”订单会在开播后、结算前被退掉。这样既能撑起实时数据，又不会真正占用库存和物流太久。代价是，店铺的退货率被长期抬高，而这项指标通常不会对观众展示。",
          "线人提供的后台截图里，某一爆款场次的结算金额，只有实时展示额度的不到一半。",
        ],
      },
      {
        heading: "当“真实”成为稀缺资源",
        paragraphs: [
          "这类操作并非某一家独有，它已经形成相对成熟的分工。对商家而言，短期数据与长期信任之间存在一笔难以算清的账。",
          "出于安全考虑，本稿隐去平台名称与具体场次信息。相关内容已同步反馈给商家侧，等待进一步核实。",
        ],
      },
    ],
    responses: [
      {
        from: "相关商家（补充说明）",
        text: "商家侧回应称，个别场次数据异常属于“渠道执行问题”，已启动内部核查。",
      },
    ],
  },
  {
    id: "canteen-relation-chain",
    title: "校园食堂承包的“关系户”链",
    categoryId: "gray",
    category: "灰色地带",
    excerpt:
      "一份招标文件的评分表上，几项“软指标”的权重高得反常。三年间，中标方换来换去，背后的联系人却总是同一批。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20investigative%20magazine%20illustration%20of%20an%20empty%20campus%20canteen%20with%20metal%20tables%2C%20muted%20warm%20palette%20of%20brick%20red%20amber%20and%20charcoal%2C%20grainy%20paper%20texture%2C%20dramatic%20chiaroscuro%20lighting%2C%20abstract%20documentary%20collage%2C%20no%20text%2C%20high%20detail&width=900&height=560&seq=heian-story-05-cover-2026&orientation=landscape",
    source: "线人代号 · 后排打饭",
    region: "华中某市",
    date: "2026-08-11",
    readMinutes: 8,
    heat: 6480,
    verified: false,
    tags: ["招标", "校园", "承包"],
    timeline: [
      { date: "2023", text: "食堂经营承包启动新一轮招标。" },
      { date: "2024", text: "评分细则中加入多项“考察项”。" },
      { date: "2026", text: "线人整理出三份不同年份的中标资料。" },
    ],
    sections: [
      {
        heading: "评分表里被放大的软指标",
        paragraphs: [
          "线人曾参与后勤相关的工作。他把三份不同年份的招标评分表放在一起，指给我们看：价格分被压得很低，而“现场考察”“运营方案”这类主观项的总权重接近一半。",
          "“同样的资质，不同的分数，差就差在这几栏。”他说，评分表本身合规，但分数怎么来的，外人看不到。",
        ],
      },
      {
        heading: "换了名字的中标方",
        paragraphs: [
          "三年间，中标的公司名称换了两次，但负责对接的联系人、经营范围乃至登记的联系方式高度相似。线人据此怀疑存在“换壳投标”。这部分目前仅有间接证据，我们未作定论。",
          "我们尝试核对公开的工商登记信息，发现部分公司注册时间与中标时间相隔极近，注册地址集中在同一栋商务楼。",
        ],
      },
      {
        heading: "学生的体感与账面的差距",
        paragraphs: [
          "承包层的变动最终会体现在餐盘里。线人回忆，每换一次承包方，菜价都会小幅上浮，“分量是先动的，价格是后动的”。",
          "本稿涉及的学校均已做匿名处理，相关问询已通过公开渠道发出，截至发稿未获回应。",
        ],
      },
    ],
    responses: [
      {
        from: "相关学校（未回应）",
        text: "我们通过公开邮箱发送问询，截至发稿未收到回复。",
      },
    ],
  },
  {
    id: "property-ten-year-ledger",
    title: "物业费去了哪：一个小区十年的账本",
    categoryId: "society",
    category: "民生暗角",
    excerpt:
      "业主想看的只有一样东西——公开明细。十年里，公示栏换了三次，账目却始终停留在“合计”一栏。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20investigative%20magazine%20illustration%20of%20residential%20building%20windows%20and%20a%20ledger%20on%20a%20table%2C%20muted%20warm%20palette%20of%20brick%20red%20amber%20and%20charcoal%2C%20grainy%20paper%20texture%2C%20dramatic%20side%20lighting%2C%20abstract%20documentary%20collage%2C%20no%20text%2C%20high%20detail&width=900&height=560&seq=heian-story-06-cover-2026&orientation=landscape",
    source: "线人代号 · 三号楼",
    region: "西南某市",
    date: "2026-08-06",
    readMinutes: 6,
    heat: 5980,
    verified: true,
    tags: ["物业", "社区", "信息公开"],
    timeline: [
      { date: "2016", text: "小区交付，物业费标准确定。" },
      { date: "2021", text: "业主首次提出查看完整明细，未获满足。" },
      { date: "2026", text: "业主代表整理了历年公示材料的复印件。" },
    ],
    sections: [
      {
        heading: "十年里只见过“合计”",
        paragraphs: [
          "线人是小区业主代表之一。他把历年公示栏的照片一张张翻给我们看：每年都有一张支出合计表，但细项常年缺位，电梯维保、绿化、公共水电这些容易出问题的部分，从未单独列出。",
          "“我们要的不是吵架，是明细。”他说，业主们反复提交书面申请，得到的答复大多是“属于内部资料”。",
        ],
      },
      {
        heading: "公共收益的那笔钱",
        paragraphs: [
          "小区里还有一笔长期被忽视的收入：电梯广告、快递柜进场费、场地租赁。这部分属于公共收益，按规定应当公开并归业主共有。线人表示，十年间他从未见过完整的收益公示。",
          "业主们做过粗略估算，仅广告类收入一项，按楼栋数量推算就不是小数目。当然，这只是一个需要被验证的估算。",
        ],
      },
      {
        heading: "把讨论拉回规则本身",
        paragraphs: [
          "这则爆料的价值不在于指控某个人，而在于呈现一个普遍处境：当公开渠道不畅，业主的监督就成了无源之水。",
          "我们已将相关问题反馈至该小区物业服务企业的公开联系方式，截至发稿未获回应。",
        ],
      },
    ],
    responses: [
      {
        from: "物业服务企业（未回应）",
        text: "截至发稿，服务企业未就明细公开问题作出回应。",
      },
    ],
  },
  {
    id: "refurb-phone-wash",
    title: "翻新二手机的“洗白”流水线",
    categoryId: "gray",
    category: "灰色地带",
    excerpt:
      "一块屏幕、一张贴膜、一次系统重置，就能让“维修机”变成“准新机”。线人描述了质检标签背后的那套流程。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20investigative%20magazine%20illustration%20of%20disassembled%20smartphones%20and%20tools%20on%20a%20cold%20bench%2C%20muted%20warm%20palette%20of%20brick%20red%20amber%20and%20charcoal%2C%20grainy%20paper%20texture%2C%20dramatic%20lighting%2C%20abstract%20documentary%20collage%2C%20no%20text%2C%20high%20detail&width=900&height=560&seq=heian-story-07-cover-2026&orientation=landscape",
    source: "线人代号 · 螺丝刀",
    region: "华南某市",
    date: "2026-07-30",
    readMinutes: 7,
    heat: 5620,
    verified: false,
    tags: ["二手交易", "质检", "翻新"],
    timeline: [
      { date: "2024", text: "线人进入一家手机翻新作坊。" },
      { date: "2025", text: "作坊接入多家线上渠道的“官方质检”标签。" },
      { date: "2026", text: "线人离职并保存了部分作业流程记录。" },
    ],
    sections: [
      {
        heading: "“准新”是一个可以批量制造的词",
        paragraphs: [
          "线人在一家翻新作坊做过质检。他描述的流程并不复杂：换屏、换电池、清洁、重置系统，然后贴上一张印着等级标签的贴纸。",
          "“标签是分级的，但分级标准没有公示。同一台机器，赶货的时候就能往上提一级。”他说，消费者看到的“99 新”，多数时候来自这张贴纸。",
        ],
      },
      {
        heading: "维修史被系统重置一并抹去",
        paragraphs: [
          "更让线人在意的是维修史。部分机型可以通过工具修改系统层面的记录，原本的维修信息在重置后不再显示。购买的消费者很难自行判断这台机器经历过什么。",
          "线人承认自己参与过其中一部分操作，这也是他愿意把这件事讲出来的原因。",
        ],
      },
      {
        heading: "链条上的每一环都在推责",
        paragraphs: [
          "当消费者发现问题，追责会依次落到渠道、质检、作坊，最后往往不了了之。本稿呈现的是个体经验，不代表所有二手商户都如此操作。",
          "相关从业资质信息我们仍在核实中，稿件如有更新会以更正的方说明。",
        ],
      },
    ],
    responses: [
      {
        from: "行业从业者（补充）",
        text: "也有同行坚持逐台检测并公示维修史，我们希望这成为常态而不是例外。",
      },
    ],
  },
  {
    id: "consumable-rep-confession",
    title: "耗材代表自述：我如何“教育”采购",
    categoryId: "industry",
    category: "行业黑幕",
    excerpt:
      "“教育”是这一行的行话。它的意思是，让采购方相信贵的那个更好，而其中差价的分成，从未出现在任何一张发票上。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20investigative%20magazine%20illustration%20of%20sample%20cases%20briefcases%20and%20an%20invoice%20under%20a%20desk%20lamp%2C%20muted%20warm%20palette%20of%20brick%20red%20amber%20and%20charcoal%2C%20grainy%20paper%20texture%2C%20dramatic%20chiaroscuro%20lighting%2C%20abstract%20documentary%20collage%2C%20no%20text%2C%20high%20detail&width=900&height=560&seq=heian-story-08-cover-2026&orientation=landscape",
    source: "线人代号 · 样本箱",
    region: "华北某市",
    date: "2026-07-25",
    readMinutes: 9,
    heat: 8190,
    verified: false,
    tags: ["采购", "回扣", "行业潜规则"],
    timeline: [
      { date: "2019", text: "线人成为某类耗材的销售代表。" },
      { date: "2023", text: "行业竞争加剧，返点方式愈发隐蔽。" },
      { date: "2026", text: "线人离职并整理出自己参与过的部分记录。" },
    ],
    sections: [
      {
        heading: "行话里的“教育”是什么意思",
        paragraphs: [
          "线人在这一行做了七年。他说，新人入职第一天学的不是产品参数，而是一套沟通话术，业内叫“教育”。",
          "“教育的核心不是介绍产品，而是让对方觉得换供应商有风险、有代价。”当采购方形成依赖，价格就不再是最重要的变量。",
        ],
      },
      {
        heading: "返点以什么形式存在",
        paragraphs: [
          "更敏感的是返点。它极少以现金形式出现，更多时候伪装成咨询费、推广费，或者通过第三方公司走账。线人提供的部分记录里，同一个项目对应了多个名目的费用。",
          "他坦言，这套做法让认真做事的产品反而没有空间，“谁老老实实报价，谁就先出局”。",
        ],
      },
      {
        heading: "线人为什么站出来",
        paragraphs: [
          "线人承认自己是链条的一部分。他把这段经历说出来，是希望有更多人意识到，采购价的每一分虚高，最终都由使用方承担。",
          "本稿不针对任何具体机构，涉及的主体信息均做了模糊处理。这是一份自述型爆料，我们无法核实其中每一项细节，请读者理性看待。",
        ],
      },
    ],
    responses: [
      {
        from: "编者按",
        text: "本文为线人自述，涉及金额与主体信息已做处理，欢迎知情者补充更具体的线索。",
      },
    ],
  },
  {
    id: "member-data-triple-sale",
    title: "被转卖三次的会员数据",
    categoryId: "network",
    category: "网络暗涌",
    excerpt:
      "一份标注着“2024 年末脱敏”的表格，在三个不同的群里被转手。脱敏脱到哪里，没人说得清。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20investigative%20magazine%20illustration%20of%20server%20racks%20and%20glowing%20data%20rows%20in%20darkness%2C%20muted%20warm%20palette%20of%20brick%20red%20amber%20and%20charcoal%2C%20grainy%20paper%20texture%2C%20dramatic%20lighting%2C%20abstract%20documentary%20collage%2C%20no%20text%2C%20high%20detail&width=900&height=560&seq=heian-story-09-cover-2026&orientation=landscape",
    source: "线人代号 · 只读权限",
    region: "线上",
    date: "2026-07-20",
    readMinutes: 7,
    heat: 7420,
    verified: false,
    tags: ["数据安全", "隐私", "黑市"],
    timeline: [
      { date: "2025", text: "一张会员表格出现在某交易群中。" },
      { date: "2026 春", text: "同一份数据以不同价格被转手多次。" },
      { date: "2026 夏", text: "线人将样本（已遮蔽全部可识别字段）提供给本站。" },
    ],
    sections: [
      {
        heading: "“脱敏”两个字值多少钱",
        paragraphs: [
          "线人是一名数据行业的从业者。他在几个交易群里反复看到同一份表格，文件名标着“脱敏版”，价格从几百到上千不等。",
          "我们看到的样本经过处理，但即便在部分遮蔽后，仍能看出字段结构相当完整：消费频次、金额区间、偏好标签，一应俱全。这些字段组合起来，足以还原出相当具体的用户画像。",
        ],
      },
      {
        heading: "数据是如何一步步流出的",
        paragraphs: [
          "线人推测，源头可能是合作方的权限管理不严，或是离职人员带走了导出文件。这类泄漏很难追溯，因为每一次转手都会重新生成一份副本，记录在一次次复制中被抹平。",
          "更麻烦的是，被泄漏的人往往毫不知情。他们接到的推销电话、收到的骚扰短信，很多时候就是这条链条的末端。",
        ],
      },
      {
        heading: "能做的其实有限，但并非没有",
        paragraphs: [
          "对个人而言，减少用同一手机号注册所有服务、定期清理授权，能降低一点风险。对企业而言，权限分级与操作留痕才是根本。",
          "本稿不展示任何可识别信息，也不提供获取渠道。相关平台我们已做匿名处理，并建议受影响方向监管渠道反映。",
        ],
      },
    ],
    responses: [
      {
        from: "数据合规从业者（受访）",
        text: "很多泄漏不是被攻破，而是被“拿走”。权限管不住人，技术再好也白搭。",
      },
    ],
  },
  {
    id: "training-loan-trap",
    title: "培训机构“学费贷”的连环套",
    categoryId: "business",
    category: "商业暗账",
    excerpt:
      "“先学后付”听起来很温柔，直到你发现，签下的是贷款合同，而退课远比报名难。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20investigative%20magazine%20illustration%20of%20a%20classroom%20desk%20with%20a%20loan%20document%20and%20phone%2C%20muted%20warm%20palette%20of%20brick%20red%20amber%20and%20charcoal%2C%20grainy%20paper%20texture%2C%20dramatic%20side%20lighting%2C%20abstract%20documentary%20collage%2C%20no%20text%2C%20high%20detail&width=900&height=560&seq=heian-story-10-cover-2026&orientation=landscape",
    source: "线人代号 · 课桌最后一排",
    region: "华东某市",
    date: "2026-07-14",
    readMinutes: 8,
    heat: 6240,
    verified: false,
    tags: ["教育培训", "分期贷", "退费"],
    timeline: [
      { date: "2024", text: "机构主推“先学后付”分期方案。" },
      { date: "2025", text: "退课申请激增，退款周期拉长。" },
      { date: "2026", text: "多位学员向本站提供了合同与还款记录。" },
    ],
    sections: [
      {
        heading: "“先学后付”是谁在垫钱",
        paragraphs: [
          "多位学员描述了同一套流程：报名时被推荐分期方案，销售强调“每个月几百块，压力很小”。真正签下的，是与第三方金融机构的借款合同，机构则一次性拿到了学费。",
          "“我以为只是分期给机构，后来才发现是向一家金融公司借钱。”学员说，从签完那一刻起，债权的对象就变了。",
        ],
      },
      {
        heading: "退课为什么这么难",
        paragraphs: [
          "想退课时，机构与金融机构会互相指向对方：机构说已提供服务、需按合同扣除费用，金融方说借款关系独立、仍需按时还款。学员被夹在中间。",
          "我们看到的几份合同里，退费条款的表述相当模糊，而学员在报名时几乎无人逐条阅读。",
        ],
      },
      {
        heading: "把风险说在前面",
        paragraphs: [
          "这类模式本身未必违法，问题在于信息披露是否充分。让学员在完全理解金融关系的前提下做选择，本该是基本要求。",
          "涉及机构已完成匿名处理，问询已发出，截至发稿未获回应。本稿不对个案定性。",
        ],
      },
    ],
    responses: [
      {
        from: "前机构课程顾问（受访）",
        text: "培训的时候明确要求把重点放在“每月多少钱”，金融的部分一带而过。",
      },
    ],
  },
  {
    id: "archive-fire",
    title: "档案室那场“恰到好处”的火灾",
    categoryId: "gray",
    category: "灰色地带",
    excerpt:
      "火只烧了一个房间，恰好是存放某批文件的那一间。消防结论指向线路老化，但线人记得，那间屋子的线路刚检修过。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20investigative%20magazine%20illustration%20of%20a%20charred%20filing%20cabinet%20and%20smoke%20stained%20walls%2C%20muted%20warm%20palette%20of%20brick%20red%20amber%20and%20charcoal%2C%20grainy%20paper%20texture%2C%20dramatic%20chiaroscuro%20lighting%2C%20abstract%20documentary%20collage%2C%20no%20text%2C%20high%20detail&width=900&height=560&seq=heian-story-11-cover-2026&orientation=landscape",
    source: "线人代号 · 灰手套",
    region: "华北某市",
    date: "2026-07-08",
    readMinutes: 7,
    heat: 8870,
    verified: false,
    tags: ["档案", "事故调查", "疑点"],
    timeline: [
      { date: "2025 冬", text: "该批文件被要求集中归档至独立房间。" },
      { date: "2026 春", text: "归档室完成一次线路检修。" },
      { date: "2026 夏", text: "房间发生火灾，过火范围高度集中。" },
    ],
    sections: [
      {
        heading: "火烧得很“精准”",
        paragraphs: [
          "线人曾在该单位负责后勤。他回忆，火势局限在存放特定批次档案的房间内，相邻房间几乎未受影响，“连门都还好好的”。",
          "消防方面给出的初步意见倾向于电气线路故障。但线人提供了一个值得注意的细节：这间屋子的线路在不久前刚完成检修，并有记录可查。",
        ],
      },
      {
        heading: "档案为何被集中到一间屋子",
        paragraphs: [
          "更早之前，这批文件原本分散在不同科室。线人记得，是有人要求把它们“统一归档，方便查阅”，随后才集中到了这间独立房间。",
          "这两件事连在一起看，才构成了疑点。单独看每一件，都可以解释。",
        ],
      },
      {
        heading: "我们做了什么",
        paragraphs: [
          "我们尝试核对公开的消防记录与检修台账，线索尚不完整。本稿呈现的是线人的观察与疑问，不是对事故原因的结论。",
          "如果读者或相关单位掌握更准确的信息，欢迎通过投稿渠道补充。我们更希望这只是一次普通的意外。",
        ],
      },
    ],
    responses: [
      {
        from: "编者按",
        text: "本稿为疑点梳理，事实以官方调查结论为准。我们保留根据新信息更新或更正的权利。",
      },
    ],
  },
  {
    id: "referral-fee-dark-pool",
    title: "招聘平台的“内推费”暗盘",
    categoryId: "workplace",
    category: "职场内幕",
    excerpt:
      "同一个岗位，标价的内推费从几百到几千不等。有人靠信息差赚钱，也有人因此错过了本该拿到的面试。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20investigative%20magazine%20illustration%20of%20a%20job%20listing%20wall%20with%20price%20tags%20and%20phones%2C%20muted%20warm%20palette%20of%20brick%20red%20amber%20and%20charcoal%2C%20grainy%20paper%20texture%2C%20dramatic%20lighting%2C%20abstract%20documentary%20collage%2C%20no%20text%2C%20high%20detail&width=900&height=560&seq=heian-story-12-cover-2026&orientation=landscape",
    source: "线人代号 · 内推码",
    region: "线上",
    date: "2026-07-02",
    readMinutes: 6,
    heat: 5460,
    verified: false,
    tags: ["招聘", "内推", "信息差"],
    timeline: [
      { date: "2024", text: "部分社群里开始公开叫卖内推名额。" },
      { date: "2025", text: "不同渠道之间出现明显价格差。" },
      { date: "2026", text: "线人整理出多个岗位的报价记录。" },
    ],
    sections: [
      {
        heading: "内推原本是件好事",
        paragraphs: [
          "内推的初衷，是让熟悉岗位的人和应聘者之间多一条通路。真实的员工推荐，确实能提高匹配效率。",
          "但当内推变成生意，事情就偏了。线人展示的记录里，同一个岗位在不同渠道的报价相差数倍，而候选人付费后，得到的往往只是一个“帮你投递”的动作。",
        ],
      },
      {
        heading: "信息差是怎么被制造出来的",
        paragraphs: [
          "这些中间人多数并非公司员工，他们靠搬运公开的招聘信息、伪造内部身份来制造稀缺感。更有甚者，会把免费的公开渠道说成“内部有人才能进”。",
          "候选人付出的钱，买到的其实是自己动动手指就能完成的事。",
        ],
      },
      {
        heading: "给求职者的一句提醒",
        paragraphs: [
          "正规企业的内推，通常不需要候选人付费。任何要求先转账再“安排面试”的说法，都值得警惕。",
          "本稿不点名任何个人或平台，仅还原这套操作方式，供读者参考。",
        ],
      },
    ],
    responses: [
      {
        from: "HR 从业者（受访）",
        text: "我们欢迎真实员工内推，但坚决反对任何形式的内推收费。",
      },
    ],
  },
];